import { lazy, Suspense } from 'react';

import { ListSkeleton, PageSkeleton } from '@/shared/components/skeletons';
import { Skeleton } from '@/shared/ui/skeleton';

/* The section and the panel load on demand; these wrappers are what the registry renders. */

const FormsSection = lazy(() => import('./components/FormsSection'));
const SubmissionPanel = lazy(() => import('./components/submissions/SubmissionPanel'));

export function LazyFormsSection() {
  return (
    <Suspense fallback={<PageSkeleton />}>
      <FormsSection />
    </Suspense>
  );
}

export function LazySubmissionPanel({ id }: { id: string }) {
  return (
    <Suspense
      fallback={
        <div className="space-y-4 p-6" aria-busy>
          <Skeleton className="h-6 w-2/3" />
          <Skeleton className="h-4 w-40" />
          <ListSkeleton rows={5} avatar={false} />
        </div>
      }
    >
      <SubmissionPanel id={id} />
    </Suspense>
  );
}
